module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-cell"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_vm._v("Cell")]), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "标题文字"
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "标题文字",
      "value": "说明文字"
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "标题文字",
      "icon": "more",
      "value": "带 icon"
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "标题文字",
      "icon": "more"
    }
  }, [_c('span', [_vm._v("icon 是图片")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/100x100.png"),
      "width": "24",
      "height": "24"
    },
    slot: "icon"
  })]), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "标题文字",
      "is-link": "",
      "value": "带链接"
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "标题文字",
      "is-link": ""
    }
  }, [_c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("这里是元素")])]), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "标题文字"
    }
  }, [_c('mt-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "icon": "back"
    }
  }, [_vm._v("按钮")])], 1), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "标题",
      "label": "描述信息",
      "is-link": ""
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "原生跳转",
      "label": "跳转到 https://fx-mui.github.io",
      "is-link": "",
      "to": "https://fx-mui.github.io"
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "路由跳转",
      "label": "跳转到 /#/toast",
      "is-link": "",
      "to": {
        name: 'Toast'
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b73dbdd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/pages/cell.vue
// module id = 265
// module chunks = 0